<template>
  <div class="pm-page">
    <main class="pm-main">

      <!-- 검색/필터 툴바 -->
      <div class="pm-toolbar">
        <div class="toolbar-row">
          <div class="field-group field-group--wide">
            <label class="field-label">상품조회</label>
            <div class="field-inline">
              <select class="pm-select" aria-label="상품조회" ref="sel_procCode" v-model="i" :disabled="isLoading" @change="changeCondition(i)">
                <option :value="noVal" disabled>상품조회</option>
                <option value="all">전체상품</option>
                <option value="L"  >L: 현지투어</option>
                <option value="V"  >V: 버라이어티</option>
                <option value="T"  >T: 페키지</option>
                <option value="G"  >G: 일본골프</option>
                <option value="F"  >F: 일본승선권</option>
                <option value="E"  >E: 티켓패스</option>
                <option value="g1" >그룹1</option>
                <option value="g2" >그룹2</option>
                <option value="g3" >그룹3</option>
                <option value="CU" >큐잉세팅</option>
                <option value="US" >지금 뜨는 상품</option>
                <option value="MN" >멤버십용 신규상품</option>
                <option value="DC" >멤버십용 상시할인상품</option>
                <option value="JS" >공동모객판매상품</option>
                <option value="DS" >전시판매</option>
                <option value="NS" >판매중지</option>
                <option value="ND" >전시중지</option>
                <option value="DL" >삭제상품</option>
              </select>
              <button type="button" class="pm-btn pm-btn--ghost" :disabled="isLoading" @click="saveSortNo">게시순서설정</button>
            </div>
          </div>

          <div class="field-group">
            <label class="field-label">여행지역</label>
            <select class="pm-select" aria-label="여행지역선택" ref="pdtArea" v-model="a" :disabled="isLoading" @change="showPdtAr(a)">
              <option :value="noVal" disabled>여행지역선택</option>
              <option value="arAll" >지역전체</option>
              <option :value="ar.baseCode" :key=a v-for="(ar,a) in arCodeList">({{ar.categoryCode}}) {{ar.codeNameKor}}</option>
            </select>
          </div>

          <div class="field-group">
            <label class="field-label">연계상품</label>
            <select class="pm-select" aria-label="연계상품조회" ref="sel_procCode" v-model="j" :disabled="isLoading" @change="showAssoPdt(j)">
              <option :value="noVal" disabled>연계상품조회</option>
              <option value="assoAll" >연계전체</option>
              <option :value="ac.assoCode" :key=i v-for="(ac,i) in assCodeList">{{ac.assoName}} ({{ ac.assoCode }})</option>
            </select>
          </div>

          <div class="field-group">
            <label class="field-label">담당매니저</label>
            <select class="pm-select" aria-label="담당매니저" ref="pdtManager" v-model="m" :disabled="isLoading" @change="showPdtMan(m)">
              <option :value="noVal" disabled>담당매니저</option>
              <option value="manAll" >매니저전체</option>
              <option :value="pm.handlerId" :key=i v-for="(pm,i) in pdtManList">{{pm.handlerNameKor}}</option>
            </select>
          </div>

          <div class="field-group field-group--wide">
            <label class="field-label">상품명 검색</label>
            <div class="field-inline">
              <input type="text" class="pm-input" v-model="sKeyword" :disabled="isLoading" placeholder="상품명 (일부가능)">
              <button type="button" class="pm-btn pm-btn--dark" ref="searchBtn" :disabled="isLoading" @click="getSalesList(sKeyword, 'sk');">
                <span v-if="!isLoading">검색 (ENTER)</span>
                <span v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;검색중</span>
              </button>
            </div>
          </div>
        </div>

        <div class="toolbar-row toolbar-row--actions">
          <button type="button" class="pm-btn pm-btn--accent" :disabled="isLoading" @click="getSalesList_and();">
            <span v-if="!isLoading">조건조합(AND) 검색</span>
            <span v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;검색중</span>
          </button>
          <button type="button" class="pm-btn pm-btn--outline-accent" :disabled="isLoading" @click="goToInsert">＋ 단일상품등록 (기본사항)</button>
        </div>
      </div>

      <!-- 검색결과 테이블 -->
      <div class="table-wrapper">
        <div class="loading-overlay" v-if="isLoading">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="mt-2 text-primary small">불러오는 중...</div>
        </div>

        <div class="table-scroll">
          <table class="pm-table">
            <thead>
              <tr>
                <th>판매처</th>
                <th>상품코드</th>
                <th>구분</th>
                <th class="col-cate">판매카테고리</th>
                <th>속성</th>
                <th>출발</th>
                <th>여행지</th>
                <th class="col-name">상품명</th>
                <th>연계코드</th>
                <th>국가</th>
                <th>교통</th>
                <th>1차</th>
                <th class="col-actions">상세설정</th>
                <th class="col-actions">기타작업</th>
                <th>비고사항</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="i" v-for="(product, i) in productMaList">
                <td>
                  <div class="seller-tags">
                    <span class="tag tag--nt" v-if="product.sellerCode_nt === 'Y' || product.sellerCode_nt == undefined">NT</span>
                    <span class="tag tag--nd" v-if="product.sellerCode_nd === 'Y' || product.sellerCode_nd == undefined">ND</span>
                  </div>
                  <input type="number" v-model="product.sortNo" class="sort-input" min="0" max="999" maxlength="4">
                </td>

                <td class="mono text-accent"><small>{{ product.pCode }}</small></td>
                <td>{{ product.salesRoute }}</td>

                <!-- 판매카테고리 -->
                <td class="col-cate">{{ this.getPdtCateNames(product.pdtCate) }}</td>

                <td v-if="product.tripProp === 'D'" class="prop-cell prop-cell--d">
                  <b>{{ product.tripProp }}</b>
                  <span class="prop-sub">{{product.stayCnt}}</span>
                </td>
                <td v-else-if="product.tripProp === 'F'" class="prop-cell prop-cell--f"><b>{{ product.tripProp }}</b></td>
                <td v-else></td>

                <td>{{ product.dptCtName }}</td>
                <td>{{ product.arName }}</td>
                <td class="col-name">{{ product.pdtNameKor }}</td>
                <td class="text-center">{{ product.assoFlag }}</td>

                <td>{{ product.ntCd }}</td>
                <td v-if="product.transFlag === '0'" class="text-warn">Y</td>
                <td v-else></td>
                <td class="first-pay">
                  {{ product.firstPayment }}
                  <span v-if="product.paymentMethod === 'P'">%</span>
                  <span v-else-if="product.paymentMethod === 'A'">원</span>
                </td>

                <td class="col-actions">
                  <div class="action-row">
                    <flag v-if="product.transFlag == '0'">
                      <button type="button" class="pm-mini pm-mini--muted" disabled>교통</button>
                    </flag>
                    <flag v-else>
                      <button type="button" class="pm-mini pm-mini--teal" @click="goToPdtTrans(product.pCode, product.salesRoute);" v-if="product.salesRoute === 'T' || product.salesRoute === 'L' || product.salesRoute === 'F'">교통</button>
                    </flag>

                    <button type="button" class="pm-mini pm-mini--amber-fill" @click="goToPrcTrans(product.pCode, product.salesRoute);" v-if="product.useFlag==='Y'">가격</button>
                    <button type="button" class="pm-mini pm-mini--amber" @click="goToPrcTrans(product.pCode, product.salesRoute);" v-else>가격</button>

                    <button type="button" class="pm-mini pm-mini--violet" @click="goToImgInsert(product.pCode);">사진</button>
                    <button type="button" class="pm-mini pm-mini--indigo" @click="goToInfo(product.pCode, product.salesRoute, product.ntCd);">수정</button>
                    <button type="button" class="pm-mini pm-mini--sky" @click="goToCopy(product.pCode, product.pdtNameKor, product.pdtCate)">복제</button>
                    <button type="button" class="pm-mini pm-mini--slate" @click="previewProduct(product.pCode)">보기</button>
                  </div>

                  <div class="chip-row">
                    <button type="button" class="chip chip--sale chip--on" @click="changeStatus('S', product.saleFlag, product.pCode)" v-if="product.saleFlag === 'Y'">판매</button>
                    <button type="button" class="chip chip--sale" @click="changeStatus('S', product.saleFlag, product.pCode)" v-else>판매</button>

                    <button type="button" class="chip chip--display chip--on" @click="changeStatus('D', product.displayFlag, product.pCode)" v-if="product.displayFlag === 'Y'">전시</button>
                    <button type="button" class="chip chip--display" @click="changeStatus('D', product.displayFlag, product.pCode)" v-else>전시</button>

                    <button type="button" class="chip chip--delete chip--danger-on" @click="changeStatus('L', product.showFlag, product.pCode)" v-if="product.showFlag == 'N'">삭제</button>
                    <button type="button" class="chip chip--delete" @click="changeStatus('L', product.showFlag, product.pCode)" v-else>삭제</button>

                    <button type="button" class="chip chip--cue chip--on" @click="setCueing('N', product.pCode)" v-if="product.cueingFlag == 'Y'">큐잉</button>
                    <button type="button" class="chip chip--cue" @click="setCueing('Y', product.pCode)" v-else>큐잉</button>
                  </div>
                </td>

                <td class="col-actions">
                  <div class="chip-row">
                    <button type="button" class="chip chip--on" @click="changeChoiceFlag(product.mdChoice, product.pCode)" v-if="product.mdChoice === 'Y'">추천</button>
                    <button type="button" class="chip" @click="changeChoiceFlag(product.mdChoice, product.pCode)" v-else>추천</button>

                    <button type="button" class="chip chip--on" @click="changeFlag('B',product.bestFlag, product.pCode)" v-if="product.bestFlag === 'Y'">베스트</button>
                    <button type="button" class="chip" @click="changeFlag('B',product.bestFlag, product.pCode)" v-else>베스트</button>

                    <button type="button" class="chip chip--on" @click="makeBadge('1',product.badgeFlag,product.pCode,product.badge)" v-if="product.badgeFlag === 'Y'">뱃지1</button>
                    <button type="button" class="chip" @click="makeBadge('1',product.badgeFlag,product.pCode,product.badge)" v-else>뱃지1</button>

                    <button type="button" class="chip chip--on" @click="makeBadge('2',product.badge2Flag,product.pCode,product.badge2)" v-if="product.badge2Flag === 'Y'">뱃지2</button>
                    <button type="button" class="chip" @click="makeBadge('2',product.badg2Flag,product.pCode,product.badge2)" v-else>뱃지2</button>
                  </div>

                  <div class="chip-row">
                    <button type="button" class="chip chip--on" @click="makeGroup('1','M',product.pCode, '1')" v-if="product.grNo == 'Y'">G1</button>
                    <button type="button" class="chip" @click="makeGroup('1','P',product.pCode, '1')" v-else>G1</button>

                    <button type="button" class="chip chip--on" @click="makeGroup('2','M',product.pCode, '2')" v-if="product.grNo2 == 'Y'">G2</button>
                    <button type="button" class="chip" @click="makeGroup('2','P',product.pCode, '2')" v-else>G2</button>

                    <button type="button" class="chip chip--on" @click="makeGroup('3','M',product.pCode, '3')" v-if="product.grNo3 == 'Y'">G3</button>
                    <button type="button" class="chip" @click="makeGroup('3','P',product.pCode, '3')" v-else>G3</button>
                  </div>

                  <div class="chip-row">
                    <button type="button" class="chip chip--on" @click="changeNewFlag(product.newFlag, product.pCode)" v-if="product.newFlag === 'Y'">신규</button>
                    <button type="button" class="chip" @click="changeNewFlag(product.newFlag, product.pCode)" v-else>신규</button>

                    <button type="button" class="chip chip--on" @click="changeJointSales(product.jointFlag, product.pCode)" v-if="product.jointFlag === 'Y'">공동</button>
                    <button type="button" class="chip" @click="changeJointSales(product.jointFlag, product.pCode)" v-else>공동</button>

                    <button type="button" class="chip chip--on" @click="changeAlwaysDCSales(product.awDCFlag, product.pCode)" v-if="product.awDCFlag === 'Y'">할인</button>
                    <button type="button" class="chip" @click="changeAlwaysDCSales(product.awDCFlag, product.pCode)" v-else>할인</button>

                    <button type="button" class="chip chip--on" @click="change_uSetFlag(product.uSetFlag, product.pCode)" v-if="product.uSetFlag === 'Y'">지금</button>
                    <button type="button" class="chip" @click="change_uSetFlag(product.uSetFlag, product.pCode)" v-else>지금</button>
                  </div>
                </td>

                <td class="remarks-cell">
                  <!-- 상품소개 -->
                  <small>{{ product.pdtRemarks }}</small>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- pagenation area -->
      <nav aria-label="Page navigation" class="pm-pager-wrap">
        <ul class="pm-pager">
          <li>
            <a class="pm-pager__link" aria-label="Previous" @click="paging('p')">&laquo;</a>
          </li>
          <li :key="j" v-for="j in this.cntPage">
            <a class="pm-pager__link" @click="paging(pg = j)">{{j}}</a>
          </li>
          <li>
            <a class="pm-pager__link" aria-label="Next" @click="paging('n')">&raquo;</a>
          </li>
        </ul>
      </nav>

    </main>
  </div>
</template>

<script>
import {genCode} from '../assets/js/genCode'
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      productMaList: { pdCate: "" },    //판매카테고리를 비교처리하기 위해 객체로 선언
      productMaList_tmp: [],
      cntProdList: 0,
      pageSize: 12,             //페이지당 데이타수
      page: 1,                  //offset기준
      cntPage: 1,               //페이지네이션 표시페이지수
      pdtPromoInfo: [],         //프로모션 정보
      pdtSortNo: 999,           //상품게시순서

      assoCode: "",             //연계코드(모아보기)
      assCodeList: [],          //연계상품코드리스트

      pdtManList: [],           //상품매니저리스트

      a: "",                    //검색조건별 초기화 변수
      i: "",
      j: "",                    //검색조건별 초기화 변수
      m: "",
      sKeyword: "",
      salesCategory: [],        //판매카테고리리스트
      salesCategoryMap: {},     //판매카테고리 코드->명칭 빠른조회용 Map (find() 반복호출 방지)

      isLoading: false,         //검색/저장 등 비동기 처리중 여부(인디케이터 및 중복클릭 방지용)
      recentlyCopiedCodes: [],  //방금 복제한 상품코드 목록(맨위 고정용, 컴포넌트 살아있는 동안만 유지)
      lastSearchParams: null,   //직전에 실행한 검색조건 (복제 후 같은 화면으로 새로고침할 때 재사용)

      arCodeList: [],            //여행지역리스트
    };
  },
  created() {
    this.productId = this.$route.query.productId;
    // 데이타베이스 쿼링테스트
    this.getSalesList("all");
    this.getPdtPrmomoInfo();
    //this.getProductPrice();
    //console.log("AccessInfo:",this.$store.state.user);
    //this.getProductPromotionPrice();
    this.getAssoCodeList()
    this.getPdtManList()            //상품관리매니저
    this.getSalesCategory();        //판매카테고리리스트
    this.getArInfoList();           //여행지역리스트
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    //추출된 상품정보의 카테고리문자열을 배열로 변환
    pdtCateArray() {
      return this.productMaList[0].pdtCate ? this.productMaList[0].pdtCate.split(",") : [];
    },

    filteredSalesCategory() {
      // console.log("pdtCateArray >>>", this.pdtCateArray);
      // console.log("salesCategory >>>", this.salesCategory);
      return this.salesCategory.filter(sc =>
        this.pdtCateArray.includes(sc.baseCode)
      );
    }
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   location.replace("/")
    // }
    //권한없는 로그인 차단
    if(this.user.handlerGrade >= 20 || this.user.handlerGrade == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    //document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";
    //엔터키 바로가기
    document.addEventListener("keydown",this.handleEnterKeyPress);
  },
  beforeUnmount() {
    document.removeEventListener("keydown",this.handleEnterKeyPress);
  },
  methods: {
    // 방금 복제한 상품코드를 목록에 추가 (전체 리로드를 안 하므로 컴포넌트 상태로 충분)
    addRecentlyCopiedCode(pCode) {
      if(!this.recentlyCopiedCodes.includes(pCode))
      {
        this.recentlyCopiedCodes.push(pCode)
      }
    },

    // 리스트 중 최근 복제상품을 seqNo 내림차순(늦게 복제된 것부터)으로 맨앞에 고정
    pinRecentlyCopiedToTop(list) {
      if(this.recentlyCopiedCodes.length === 0 || !Array.isArray(list) || list.length === 0)
      {
        return list
      }

      const pinned = []
      const rest = []

      list.forEach(item => {
        if(this.recentlyCopiedCodes.includes(item.pCode))
        {
          pinned.push(item)
        }
        else
        {
          rest.push(item)
        }
      })

      if(pinned.length === 0)
      {
        return list
      }

      // 늦게 복제된(=seqNo가 큰) 상품이 맨위로
      pinned.sort((a, b) => (b.seqNo ?? 0) - (a.seqNo ?? 0))

      return [...pinned, ...rest]
    },

    // 직전에 실행했던 검색조건 그대로 목록만 다시 조회 (복제 후 필터 유지한 채 새로고침용)
    async refreshCurrentList() {
      if(this.lastSearchParams && this.lastSearchParams.type === 'and')
      {
        await this.getSalesList_and()
      }
      else if(this.lastSearchParams)
      {
        await this.getSalesList(this.lastSearchParams.pNum, this.lastSearchParams.sFlag)
      }
      else
      {
        await this.getSalesList("all")
      }
    },

    //엔터키 바로작동
    handleEnterKeyPress(event)
    {
      if(event.keyCode === 13)
      {
        if(this.isLoading) return;   // 검색중에는 엔터 무시(중복호출 방지)
        this.$refs.searchBtn.click();
        // this.searchSettleData()
      }
    },

    // 판매카테고리 + 연계코드 + 담당매니저 + 상품명 4개 조건 AND 조합검색
    async getSalesList_and() {
      if(this.isLoading) return;   // 이미 검색중이면 중복요청 방지

      const cateCodes = ['L','V','T','G','F','E']   // g1/CU/US 등 특수뷰는 조합대상에서 제외
      let cate    = cateCodes.includes(this.i) ? this.i : ''
      let ar      = (this.a && this.a !== 'noVal' && this.a !== 'arAll') ? this.a : ''
      let asso    = (this.j && this.j !== 'noVal' && this.j !== 'assoAll') ? this.j : ''
      let manager = (this.m && this.m !== 'noVal' && this.m !== 'manAll') ? this.m : ''
      let keyword = this.sKeyword ? this.sKeyword.trim() : ''

      if(!cate && !ar && !asso && !manager && !keyword)
      {
        this.$swal.fire('', '검색조건을 하나 이상 선택(입력)해주세요.', 'warning')
        return false
      }

      this.lastSearchParams = { type: 'and' }   // 직전 검색조건 기억(복제 후 새로고침용)

      this.isLoading = true
      try
      {
        this.productMaList_tmp = await this.$api("/api/salesList_and", {param: [
          cate, cate, ar, ar, asso, asso, manager, manager, keyword, keyword
        ]});

        // 최근 복제한 상품을 표시순서와 무관하게 맨위로 고정
        this.productMaList_tmp = this.pinRecentlyCopiedToTop(this.productMaList_tmp)

        this.cntProdList = this.productMaList_tmp.length
        this.cntPage = Math.ceil(this.cntProdList / this.pageSize)
        this.page = 1
        this.productMaList = this.productMaList_tmp.slice(0, this.pageSize)

        if(this.productMaList.length < 1)
        {
          this.$swal.fire('', '데이타가 없습니다', 'info')
          return false
        }
      }
      finally
      {
        this.isLoading = false
      }
    },

    // 상품별 판매카테고리 명칭 반환 (Map 조회로 O(1) - 매 렌더링마다 find() 반복하던 부분 개선)
    getPdtCateNames(pdtCate) {
      if (!pdtCate) return '';

      return pdtCate.split(',')
        .map(code => this.salesCategoryMap[code] || code)
        .join(', ');
    },

    // 판매카테고리 리스트
    async getSalesCategory() {
      let salesCategory = await this.$api("/api/getSalesCategory", {});

      if(salesCategory.length > 0)
      {
        this.salesCategory = salesCategory
        // 코드->명칭 조회용 Map 사전 구성 (getPdtCateNames에서 매번 find() 하지 않도록)
        this.salesCategoryMap = salesCategory.reduce((map, sc) => {
          map[sc.baseCode] = sc.codeNameKor
          return map
        }, {})
      }
      // console.log("salesCategory:",this.salesCategory);
    },

     async getSalesList(pNum, sFlag) {     //sFlag => 검색키워드 검색플래그
      if(this.isLoading) return;   // 이미 검색중이면 중복요청 방지

      // this.pdtPriceMxMn = await this.$api("/api/pdtPriceMxMn", {param:[]});
      // console.log("pdtPriceMxMn:",this.pdtPriceMxMn);
      //alert(pNum + "/" + sFlag);

      this.lastSearchParams = { type: 'single', pNum, sFlag }   // 직전 검색조건 기억(복제 후 새로고침용)

      this.isLoading = true
      try
      {
        this.productMaList_tmp = [];
        if(sFlag == undefined )
        {
          if(pNum === "all")
          {
            this.productMaList_tmp = await this.$api("/api/salesList", {});
          }
          else if(pNum === "L" || pNum === "V" || pNum === "T" || pNum === "G" || pNum === "F" || pNum === "E")
          {
            this.productMaList_tmp = await this.$api("/api/salesList1", {param:[pNum, "%"]});
          }
          else if(pNum === "DS")       //전시판매
          {
            this.productMaList_tmp = await this.$api("/api/salesList_onSale", {});
            alert("전시판매 중인 상품은 설정기준이며, 실제 판매여부는 가격설정에 따라 달라질 수 있습니다.")
          }
          else if(pNum === "NS")       //판매중지
          {
            this.productMaList_tmp = await this.$api("/api/salesList_noSale", {param:["%", 'N']});
          }
          else if(pNum === "ND")       //전시중지
          {
            this.productMaList_tmp = await this.$api("/api/salesList_noDisplay", {param:["%", 'N']});
          }
          else if(pNum === "g1")
          {
            this.productMaList_tmp = await this.$api("/api/salesListForGroup1", {});
          }
          else if(pNum === "g2")
          {
            this.productMaList_tmp = await this.$api("/api/salesListForGroup2", {});
          }
          else if(pNum === "g3")
          {
            this.productMaList_tmp = await this.$api("/api/salesListForGroup3", {});
          }
          else if(pNum === "CU")      //큐잉세팅상품
          {
            this.productMaList_tmp = await this.$api("/api/salesListForCueing", {});
          }
          else if(pNum === "US")      //지금 눈여겨 볼 상품(지금 세팅상품)
          {
            this.productMaList_tmp = await this.$api("/api/salesListForUserSetting", {});
          }
          else if(pNum === "MN")      //멤버십용 신규상품
          {
            this.productMaList_tmp = await this.$api("/api/salesList_memNew", {});
          }
          else if(pNum === "DC")      //멤버십용 상시할인상품
          {
            this.productMaList_tmp = await this.$api("/api/salesList_memAwDC", {});
          }
          else if(pNum === "JS")      //공동모객판매상품
          {
            this.productMaList_tmp = await this.$api("/api/salesList_joitSales", {});
          }
          else if(pNum === "DL")      //삭제상품추출
          {
            this.productMaList_tmp = await this.$api("/api/salesList_del", {});
          }
          else
          {
            this.productMaList_tmp = await this.$api("/api/salesList", {});
          }
        }
        else if(sFlag === "sk")
        {
          this.productMaList_tmp = await this.$api("/api/salesListByKeyword", {param:["%" + pNum + "%"]});
        }

        else if(sFlag === "ar")
        { 
          if(pNum === "arAll")
          {
            this.productMaList_tmp = await this.$api("/api/salesList", {});
          }
          else
          {
            this.productMaList_tmp = await this.$api("/api/salesList_arCd", {param: [ pNum ]});
          }
        }

        else if(sFlag === "asso")
        {
          if(pNum === "assoAll")
          {
            this.productMaList_tmp = await this.$api("/api/asso_salesList", {});
          }
          else
          {
            this.productMaList_tmp = await this.$api("/api/asso_salesList1", {param: [ pNum ]});
          }
        }
        else if(sFlag === "manager")
        {
          if(pNum === "manAll")
          {
            this.productMaList_tmp = await this.$api("/api/salesList", {});
          }
          else
          {
            this.productMaList_tmp = await this.$api("/api/salesListbyMan", {param: [ pNum ]});
          }
        }

        //console.log("productMaList_tmp>>>>>>", this.productMaList_tmp)

        // 최근 복제한 상품을 표시순서와 무관하게 맨위로 고정
        this.productMaList_tmp = this.pinRecentlyCopiedToTop(this.productMaList_tmp)

        this.productMaList = this.productMaList_tmp
        this.cntProdList = this.productMaList_tmp.length;
        this.cntPage = Math.ceil(this.cntProdList / this.pageSize); //올림처리

        this.productMaList = this.productMaList_tmp.slice(0, this.pageSize); //시작idx, 지정번째idx-1
        if(this.productMaList.length < 1) {
          this.$swal.fire('', '데이타가 없습니다', 'info');
          return false;
        }
        // console.log("productMaList:",this.productMaList);
      }
      finally
      {
        this.isLoading = false
      }
    },
    paging(val){
        this.cntProdList = this.productMaList_tmp.length;

        this.cntPage = Math.ceil(this.cntProdList / this.pageSize); //올림처리

        let offSet = 0;
        //console.log("page:",this.page);

        //페이지 초기
        if(val == undefined) {
          this.page = 1;
        }
        else {
          if(val === "p") {
            this.page--;
            if(this.page < 1) {
              this.page = 1;
              this.$swal.fire('', '시작페이지입니다', 'info')
            }
          }
          else if(val === "n") {
            this.page++;
            if(this.page > this.cntPage) {
              this.page = this.cntPage;
              this.$swal.fire('', '마지막페이지입니다', 'info')
            }
          }
          else{
            this.page = val;
          }
        }
        offSet = (this.page-1)*this.pageSize;
        this.productMaList = this.productMaList_tmp.slice(offSet, offSet+this.pageSize); //시작idx, 지정번째idx-1

        if(this.productMaList.length < 1) {
          this.$swal.fire('', '데이타가 없습니다', 'info');
          return false;
        }
    },
    // async changeCondition(i) {
    //   this.j = "noVal"
    //   this.m = "noVal"
    //   this.sKeyword = ""
    //   this.getSalesList(i);
    // },
    // async showAssoPdt(j) {
    //   this.i = "noVal"
    //   this.m = "noVal"
    //   this.sKeyword = ""      
    //   this.getSalesList(j, "asso")
    // },

    // //담당매니저별 모아보기
    // async showPdtMan(m) {
    //   this.i = "noVal"
    //   this.j = "noVal"
    //   this.sKeyword = ""      
    //   this.getSalesList(m, "manager")
    // },

    // 수정 후 (개별 단일조건 즉시검색 기능은 그대로 유지, 서로 초기화만 제거)
    async changeCondition(i) {
      this.getSalesList(i);
    },
    async showPdtAr(a) {
      this.getSalesList(a, "ar")
    },    
    async showAssoPdt(j) {
      this.getSalesList(j, "asso")
    },
    async showPdtMan(m) {
      this.getSalesList(m, "manager")
    },

    goToInsert() {
      this.$router.push({path: '/create'});
    },
    goToDetail(pdtCode) {
      //console.log(pdtCode);
      this.$router.push({path: '/detail', query: {productId: pdtCode}});
    },

    async getPdtManList(){
      let pdtManList = await this.$api("/api/pdtManagerInfo", {param: [ "Y", "Y"]})
      if(pdtManList.length > 0)
      {
        this.pdtManList = pdtManList
      }
      //console.log("pdtManList:", pdtManList)
    },

    //복제상품의 상품코드생성
    async genCode(param) {
      let rtnCode = "";

      let today = new Date();
        let yy = today.getFullYear().toString().slice(-2);
        let mm = today.getMonth() + 1;
        let dd = today.getDate();
        let ymd = `${yy}${mm}${dd}`;
        let dCd = param + ymd;

        rtnCode = await genCode(this.$api, dCd);

        return rtnCode
    }, 

    //상품 복제기능
    async goToCopy(pCode, pName, pCate) {
      //console.log(pCode, pName)
      if(pName.length > 64)
      {
        this.$swal.fire("","원본상품의 제목은 64자로 제한됩니다.","warning")
        return false;
      }


      // 복제상품코드생성
      let hCd = ""
      hCd = pCode.charAt(0) + "-"
      
      let newCode = ""
      newCode = await this.genCode(hCd) + "C"     //복제상품C

      let chk_pdtCode = await this.$api("/api/checkDub_pdtCode", { param: [newCode] });
      
      if (chk_pdtCode.length > 0) 
      {
        this.$swal.fire("","상품코드가 중복되었습니다. 복제를 다시 해주십시오.","warning")
        return false;
      }
      else
      {
        let pCode_c     = newCode
        let pName_c     = "(복제_)"+pName
        let saleStat    = 'N'
        let handlerId   = this.user.handlerId
        let saleFlag    = 'N'
        let displayFlag = 'N'

        // let copyPdtInfo = await this.$api("/api/proc_copyPdtInfo", {param: [
        //   pCode, pName, pCode_c, pName_c, saleStat, handlerId
        // ]});

        let copyPdtInfo = await this.$api("/api/proc_copyPdtInfo_new", {param: [
          pCode, pName, pCode_c, pName_c, saleStat, handlerId, saleFlag, displayFlag, pCate
        ]});

        if(copyPdtInfo.affectedRows >= 0)
        {
          try
          {
            let copyRes = await this.$api("/api/copyFolder", {
              source: pCode,
              destination: newCode 
            })
            //alert(copyRes.data.message)
            alert(copyRes.message)
            this.addRecentlyCopiedCode(newCode)   // 복제상품 목록 맨위 고정용 표시

            // 전체 리로드 대신, 보고있던 필터조건 그대로 목록만 다시 조회
            await this.refreshCurrentList()
          }
          catch(error)
          {
            console.error(error)
            this.$swal.fire("","원본상품에 이미지가 없어 복제되지 않았습니다. 복제한 상품의 이미지를 등록해주세요.", "warning")
          }
        }
        else
        {
          this.$swal.fire("","원본상품이 미완성인 관계로 미완성 상태로 복제가 되었습니다. 복제한 상품을 완성해주세요.", "warning")
          return false
        }
      }
    },
    
    // mixins에 있는 공통함수 호출샘플
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    // goToPdtTrans(pdtCode, salesRoute) {
    //   this.$router.push({path: '/productTransInsert', query: {productId: pdtCode, salesRoute: salesRoute}});
    // },
    // goToPrcTrans(pdtCode, salesRoute) {
    //   this.$router.push({path: '/ma_ProductPriceInsert', query: {productId: pdtCode, salesRoute: salesRoute}});
    // },
    // goToPrcOption(pdtCode, salesRoute) {
    //   this.$router.push({path: '/productOptionInsert', query: {productId: pdtCode, salesRoute: salesRoute}});
    // },

    // goToImgInsert(pdtCode) 
    // {
    //   // 이미지 저장패스
    //   this.$router.push({path: '/image_insert', query: {productId: pdtCode}});
    // },
    // goToInfo(pdtCode, salesRoute, ntCd) 
    // {
    //   // 이미지 저장패스
    //   this.$router.push({path: '/productInfo', query: {productId: pdtCode, salesRoute: salesRoute, ntCd: ntCd}});
    // },

    // 새창오픈 방식으로 변경
    goToPdtTrans(pdtCode, salesRoute) {
      let routeData = this.$router.resolve({path: '/productTransInsert', query: {productId: pdtCode, salesRoute: salesRoute}});
      window.open(routeData.href, '_blank');
    },
    goToPrcTrans(pdtCode, salesRoute) {
      let routeData = this.$router.resolve({path: '/ma_ProductPriceInsert', query: {productId: pdtCode, salesRoute: salesRoute}});
      window.open(routeData.href, '_blank');
    },
    goToPrcOption(pdtCode, salesRoute) {
      let routeData = this.$router.resolve({path: '/productOptionInsert', query: {productId: pdtCode, salesRoute: salesRoute}});
      window.open(routeData.href, '_blank');
    },
    goToImgInsert(pdtCode) 
    {
      // 이미지 저장패스

      let routeData = this.$router.resolve({path: '/image_insert', query: {productId: pdtCode}});
      window.open(routeData.href, '_blank');
    },
    goToInfo(pdtCode, salesRoute, ntCd) 
    {
      // 이미지 저장패스
      let routeData = this.$router.resolve({path: '/productInfo', query: {productId: pdtCode, salesRoute: salesRoute, ntCd: ntCd}});
      window.open(routeData.href, '_blank');
    },

    previewProduct(pdtCode) 
    {
      // 상품미리보기
      //this.$router.push({path: '/productDetail_preview', query: {productId: pdtCode}});
      window.open('/detail?productId=' + pdtCode,'PreView', 'height=1000,width=1200,top=100,left=100,resizable=yes,scrollbars=yes')
      // window.open('/productDetail_preview?productId=' + pdtCode,'PreView', 'height=1000,width=1000,top=100,left=100,resizable=yes,scrollbars=yes')
    },

    //여행지역리스트
    async getArInfoList() {
      let arCodeList = await this.$api("/api/baseCategory", {param: "arCd"});
      
      if(arCodeList.length > 0)
      {
        this.arCodeList = arCodeList
      }
      // console.log("arCodeList:>>>>",this.arCodeList);
    },
    
    //연계상품코드리스트
    async getAssoCodeList() {
      let assCodeList = await this.$api("/api/assCodeList", {});
      
      if(assCodeList.length > 0)
      {
        this.assCodeList = assCodeList
      }
      // console.log("assCodeList:",this.assCodeList);
    },

    // getProductPrice() {
    //   let productPrice = this.$api("/api/productPrice", {param: [this.productId]});
    //   console.log("productPrice",productPrice);
    // },

    //상품별 프로모션 정보
    async getPdtPrmomoInfo() {
      let pdtPromoInfo = await this.$api("/api/pdtPromotionInfo", {});
      if(pdtPromoInfo.length > 0) {
        this.pdtPromoInfo = pdtPromoInfo;
      }
      //console.log("pdtPromoInfo",this.pdtPromoInfo);
    },

    //상품그루핑
    // makeGroup('1','M',product.pCode, product.grNo)
    async makeGroup(val, gFlag, pCode, grNo)    //생성그룹번호, 작업(P:생성/M:제거), 상품코드, 기존그룹번호
    {
      if(gFlag === "M")
      {
        this.$swal.fire({
          html: grNo + '그룹에서 제거하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '네',
          cancelButtonText: '아니오',
        }).then(async (res) => {
          if(res.isConfirmed)
          {
            await this.updatePdtGroup("N", pCode, grNo)     //그루핑해제
          }
        })
      }
      else if(gFlag === "P")
      {
        if(val)
        {
          this.$swal.fire({
            html: val+'그루핑하시겠습니까?<br>(※그룹상품은 최신순으로 4개까지 표시됩니다.)',
            showCancelButton: true,
            confirmButtonText: '네',
            cancelButtonText: '아니오',
          }).then(async (res) => {
            if(res.isConfirmed)
            {
              await this.updatePdtGroup(val, pCode, "")     //그루핑처리
            }
          })
        }
      }
    },

    //상품 그룹핑 or 언그루핑
    async updatePdtGroup(val, pCode, grNo){
      // alert("val:" + val + "/ pCode:" + pCode)
      
      let res_updPdtGrouping = []

      if(val === "N")        //그루핑 해제
      {
        if(grNo === "1")
        {
          res_updPdtGrouping = await this.$api("/api/upd_pdtGrouping1", { param: [val, pCode] })
        }
        else if(grNo === "2")
        {
          res_updPdtGrouping = await this.$api("/api/upd_pdtGrouping2", { param: [val, pCode] })
        }
        else if(grNo === "3")
        {
          res_updPdtGrouping = await this.$api("/api/upd_pdtGrouping3", { param: [val, pCode] })
        }
      }
      else if(val != "N")        //그루핑 적용
      {
        if(val === "1")
        {
          res_updPdtGrouping = await this.$api("/api/upd_pdtGrouping1", { param: ["Y", pCode] })
        }
        else if(val === "2")
        {
          res_updPdtGrouping = await this.$api("/api/upd_pdtGrouping2", { param: ["Y", pCode] })
        }
        else if(val === "3")
        {
          res_updPdtGrouping = await this.$api("/api/upd_pdtGrouping3", { param: ["Y", pCode] })
        }
      }

      if(res_updPdtGrouping.affectedRows < 0)
      {
        this.$swal.fire("","업데이트에 실패하였습니다. 재시도 해주세요", "warning")
        return false;
      }
      else
      {
        this.$swal.fire("","상품그룹정보가 업데이트되었습니다.", "info")
        location.reload(true)
      }


      // let res_updPdtGrouping = await this.$api("/api/upd_pdtGrouping", { param: [val, pCode, grNo] })
      // if(res_updPdtGrouping.affectedRows < 0)
      // {
      //   this.$swal.fire("","업데이트에 실패하였습니다. 재시도 해주세요", "warning")
      //   return false;
      // }
      // else
      // {
      //   this.$swal.fire("","상품그룹정보가 업데이트되었습니다.", "info")
      //   location.reload(true)
      // }
    },

    // 큐잉견적서를 상품상세로 갈음처리
    async setCueing(param, pdtCode) {
      // let cUrl = ""
      if(param =="Y")
      {
        const { value: cUrl } = await this.$swal.fire({
          html: '큐잉견적서 URL을 입력하세요',
          input: 'text',
          //inputLabel: '뱃지표시',
          inputPlaceholder: "큐잉견적서 URL을 입력하세요"
        })

        //console.log("badgeTxt:",badgeTxt,"//badge:",badge)

        if (cUrl) {
          this.$swal.fire({
            html: `${cUrl}의 견적서가 상품상세로 표시됩니다`,
            showCancelButton: true,
            confirmButtonText: '네',
            cancelButtonText: '아니오',
          }).then(async (result) => {
            if (result.isConfirmed) {
              await this.$api("/api/setCueingUrl", {param: [param, cUrl, pdtCode ]});
              // 상태변경 후, 갱신
              this.getSalesList("all");
              this.$swal.fire('', '세팅완료', 'success')
            }
          })
        }
      }
      else if(param =="N")
      {
        let cUrl = ""

        this.$swal.fire({
            html: '큐잉견적서를 삭제합니다',
            showCancelButton: true,
            confirmButtonText: '네',
            cancelButtonText: '아니오',
          }).then(async (result) => {
            if (result.isConfirmed) {
              await this.$api("/api/setCueingUrl", {param: [param, cUrl, pdtCode ]});
              // 상태변경 후, 갱신
              this.getSalesList("all");
              this.$swal.fire('', '삭제완료', 'success')
            }
          })
      }
    },

    async makeBadge(bFlag,badgeFlag,pdtCode,badge)     //bFlag=>뱃지1,2
    {
      let badgeFlag1 = ""
      let badgeFlag2 = ""

      if(bFlag === "1")       //Badge1
      {
        if(badgeFlag != 'Y' && badgeFlag != 'N')
        {
          badgeFlag1 = "N"
        }
        else
        {
          badgeFlag1 = badgeFlag
        }
        
        if(badgeFlag1 =="Y")
        {
          this.$swal.fire({
            html: '상품의 뱃지1을 탈착합니까?',
            showCancelButton: true,
            confirmButtonText: '네',
            cancelButtonText: '아니오',
          }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              //let cStatus = (badgeFlag1 === "Y") ? "N" : "Y"
              let cStatus = 'N'
              //console.log("param:",cStatus, pdtCode);
              await this.$api("/api/changePdtBadgeStatus", {param: [cStatus, badge, pdtCode ]});
              // 상태변경 후, 갱신
              this.getSalesList("all");
              this.$swal.fire('', '뱃지1탈착완료', 'success')
            }
          })
        }
        else
        {
          const { value: badgeTxt } = await this.$swal.fire({
            html: '상품에 뱃지1을 부착합니다(10자 이내)',
            input: 'text',
            //inputLabel: '뱃지표시',
            inputPlaceholder: badge,
            inputAttributes: {
              maxlength: '10'           // 최대입력 수
            }
          })

          //console.log("badgeTxt:",badgeTxt,"//badge:",badge)

          if (badgeTxt) {
            this.$swal.fire('',`새로 등록된 뱃지1: ${badgeTxt}`)
            let cStatus = 'Y'
            await this.$api("/api/changePdtBadgeStatus", {param: [cStatus, badgeTxt, pdtCode ]});
            // 상태변경 후, 갱신
            this.getSalesList("all");
            this.$swal.fire('', '부착완료', 'success')
          }
        }
      }
      else if(bFlag === "2")       //Badge2
      {
        //alert("Badge2")
        if(badgeFlag != 'Y' && badgeFlag != 'N')
        {
          badgeFlag2 = "N"
        }
        else
        {
          badgeFlag2 = badgeFlag
        }

        if(badgeFlag2 =="Y")
        {
          this.$swal.fire({
            html: '상품의 뱃지2를 탈착합니까?',
            showCancelButton: true,
            confirmButtonText: '네',
            cancelButtonText: '아니오',
          }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              //let cStatus = (badgeFlag1 === "Y") ? "N" : "Y"
              let cStatus = 'N'
              await this.$api("/api/changePdtBadgeStatus2", {param: [cStatus, badge, pdtCode ]});
              // 상태변경 후, 갱신
              this.getSalesList("all");
              this.$swal.fire('', '뱃지2탈착완료', 'success')
            }
          })
        }
        else
        {
          const { value: badgeTxt } = await this.$swal.fire({
            html: '상품에 뱃지2를 부착합니다(10자 이내)',
            input: 'text',
            //inputLabel: '뱃지표시',
            inputPlaceholder: badge,
            inputAttributes: {
              maxlength: '10'           // 최대입력 수
            }
          })
          if (badgeTxt) {
            this.$swal.fire('',`새로 등록된 뱃지2: ${badgeTxt}`)
            let cStatus = 'Y'
            await this.$api("/api/changePdtBadgeStatus2", {param: [cStatus, badgeTxt, pdtCode ]});
            // 상태변경 후, 갱신
            this.getSalesList("all");
            this.$swal.fire('', '뱃지2부착완료', 'success')
          }
        }
      }
    },    
    changeChoiceFlag(mdChoice, pdtCode) 
    {
      // 변경전 확인
      this.$swal.fire({
        text: '추천상태(추천Yes<->추천No)변경?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let cStatus = (mdChoice === "Y") ? "N" : "Y"
          await this.$api("/api/changePdtChoiceStatus", {param: [cStatus, pdtCode]});
          // 상태변경 후, 갱신
          this.getSalesList("all");
          this.$swal.fire('', '변경완료', 'success')
        // deny 버튼클릭 시 처리루틴
        // } else if (result.isDenied) {
        //   this.$swal.fire('Changes are not saved', '', 'info')
        }
      })
    },
    changeNthereFlag(nrFlag, pdtCode) 
    {
      // 변경전 확인
      this.$swal.fire({
        text: 'Nthere(지정Yes<->지정No)지정?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let cStatus = (nrFlag === "Y") ? "N" : "Y"
          await this.$api("/api/changePdtNthereStatus", {param: [cStatus, pdtCode]});
          // 상태변경 후, 갱신
          this.getSalesList("all");
          this.$swal.fire('', '변경완료', 'success')
        // deny 버튼클릭 시 처리루틴
        // } else if (result.isDenied) {
        //   this.$swal.fire('Changes are not saved', '', 'info')
        }
      })
    },

    // changeVarietyFlag(vrFlag, pdtCode) 
    // {
    //   // 변경전 확인
    //   this.$swal.fire({
    //     title: 'Variety(지정Yes<->지정No)지정?',
    //     showCancelButton: true,
    //     confirmButtonText: '변경',
    //     cancelButtonText: '취소',
    //   }).then(async (result) => {
    //     /* Read more about isConfirmed, isDenied below */
    //     if (result.isConfirmed) {
    //       let cStatus = (vrFlag === "Y") ? "N" : "Y"
    //       await this.$api("/api/changePdtVarietyStatus", {param: [cStatus, pdtCode]});
    //       // 상태변경 후, 갱신
    //       this.getSalesList("all");
    //       this.$swal.fire('', '변경완료', 'success')
    //     // deny 버튼클릭 시 처리루틴
    //     // } else if (result.isDenied) {
    //     //   this.$swal.fire('Changes are not saved', '', 'info')
    //     }
    //   })
    // },

    changeFlag(param, flag, pdtCode) 
    {
      if(param === "B")           //베스트상품
      {
        this.$swal.fire({
          text: 'Best(지정Yes<->지정No)지정?',
          showCancelButton: true,
          confirmButtonText: '변경',
          cancelButtonText: '취소',
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            let cStatus = (flag === "Y") ? "N" : "Y"
            await this.$api("/api/changePdtBestStatus", {param: [cStatus, pdtCode]});
            // 상태변경 후, 갱신
            this.getSalesList("all");
            this.$swal.fire('', '변경완료', 'success')
          // deny 버튼클릭 시 처리루틴
          // } else if (result.isDenied) {
          //   this.$swal.fire('Changes are not saved', '', 'info')
          }
        })
      }

      // if(param === "G")           //골프상품
      // {
      //   this.$swal.fire({
      //     title: 'Golf(지정Yes<->지정No)지정?',
      //     showCancelButton: true,
      //     confirmButtonText: '변경',
      //     cancelButtonText: '취소',
      //   }).then(async (result) => {
      //     if (result.isConfirmed) {
      //       let cStatus = (flag === "Y") ? "N" : "Y"
      //       await this.$api("/api/changePdtGolfStatus", {param: [cStatus, pdtCode]});
      //       // 상태변경 후, 갱신
      //       this.getSalesList("all");
      //       this.$swal.fire('', '변경완료', 'success')
      //     }
      //   })
      // }
    },

    changeStatus(param, val, pdtCode)             // SA, S, D, L
    {
      // 변경전 확인
      this.$swal.fire({
        text: '판매상태(판매<->중지)변경?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let sStatus = (val == "Y") ? "N" : "Y"

          if(param === "SA")
          {
            await this.$api("/api/changePdtSalesStatus", {param: [sStatus, pdtCode]});            
          }
          else if(param === "S")
          {
            await this.$api("/api/changePdtSalesStatus_sale", {param: [sStatus, pdtCode]});            
          }
          else if(param === "D")
          {
            await this.$api("/api/changePdtSalesStatus_display", {param: [sStatus, pdtCode]});            
          }
          else if(param === "L")
          {
            await this.$api("/api/changePdtSalesStatus_show", {param: [sStatus, pdtCode]});            
          }
          
          // 상태변경 후, 갱신
          this.getSalesList("all");
          this.$swal.fire('', '변경완료!', 'success')
        // deny 버튼클릭 시 처리루틴
        // } else if (result.isDenied) {
        //   this.$swal.fire('Changes are not saved', '', 'info')
        }
      })
    },

    //신규상품 플래깅
    changeNewFlag(newFlag, pdtCode) 
    {
      // 변경전 확인
      this.$swal.fire({
        text: '멤버십전용 신규상품할인용(지정Yes<->지정No)지정?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let cStatus = (newFlag === "Y") ? "N" : "Y"
          await this.$api("/api/changePdtNewStatus", {param: [cStatus, pdtCode]});
          // 상태변경 후, 갱신
          this.getSalesList("all");
          this.$swal.fire('', '변경완료', 'success')
        // deny 버튼클릭 시 처리루틴
        // } else if (result.isDenied) {
        //   this.$swal.fire('Changes are not saved', '', 'info')
        }
      })
    },

    //지금 뜨는 여행 플래깅
    change_uSetFlag(newFlag, pdtCode) 
    {
      this.$swal.fire({
        text: '지금 눈여겨볼 상품(지정Yes<->지정No)지정?',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let uSetFlag = (newFlag === "Y") ? "N" : "Y"
          console.log(uSetFlag, pdtCode)
          let res = await this.$api("/api/changePdt_uSetStatus", {param: [uSetFlag, pdtCode]});
          if(res.affctedRows < 0) {
            this.$swal.fire('', '변경실패<br>관리자 문의요망', 'warning')
            return false;
          }
          else 
          {
            // 상태변경 후, 갱신
            this.getSalesList("all");
            this.$swal.fire('', '변경완료', 'success')
          }
        }
      })
    },

    changeMixProduct(pdtCode) 
    {
      // 변경전 확인
      this.$swal.fire({
        text: '결합상품 생성전환?',
        showCancelButton: true,
        confirmButtonText: '전환',
        cancelButtonText: '취소',
      }).then(async (result) => {
        if (result.isConfirmed) {
          // alert(pdtCode);
          // this.$router.push({path: '/salesMix', query: {}});
          //Mix상품코드생성
          let timeStamp = "";
          let today = new Date();   
          let yyyy = today.getFullYear();
          let mm = today.getMonth()+1;
          let dd = today.getDate();
          let ymd = `${yyyy}${mm}${dd}`
          //console.log(`ymd: ${ymd}`);
          timeStamp = today.getTime(); // 상품코드에 들어갈 타임스탬프
          let catCode = pdtCode.charAt(0);
          let mxPdtCode = catCode+"-"+ymd+"-"+timeStamp;

          let resIns_product_mix = await this.$api("/api/makeMixProduct", {param: [pdtCode]});
          if(Object.keys(resIns_product_mix)[0] === 'error') {
            this.$swal.fire('', '결합상품 기본정보 생성오류<br>관리자 문의요망', 'warning')
          }
          else {
            //let resIns_product_mix_img = await this.$api("/api/productTmpImgInsert",{param: "MX-"+pdtCode});
            let resIns_product_mix_img = await this.$api("/api/productTmpImgInsert",{param: "MX-"+mxPdtCode});
            if(Object.keys(resIns_product_mix_img)[0] === 'error') {
              this.$swal.fire('', '결합상품 기초이미지 생성오류<br>관리자 문의요망', 'warning') 
            }
            else {
              let resUpd_product_mix_code = await this.$api("/api/updateMixPdtCode", {param: [mxPdtCode, this.user.handlerId,pdtCode]});
              if(resUpd_product_mix_code.affectedRows < 0 || resUpd_product_mix_code.affectedRows === undefined){
                this.$swal.fire('', '결합상품 기본이미지 생성오류<br>관리자 문의요망', 'warning')
              }
              else {
                //let resIns_pdtQty = await this.$api("/api/productQtyInsert",{param: ["MX-"+pdtCode,this.user.handlerId]});
                let resIns_pdtQty = await this.$api("/api/productQtyInsert",{param: ["MX-"+mxPdtCode,this.user.handlerId]});
                if(Object.keys(resIns_pdtQty)[0] === 'error') {
                  this.$swal.fire('', '결합상품 기본상품수량 생성오류<br>관리자 문의요망', 'warning')
                }
                else {
                  //this.getSalesList("all");
                  this.$swal.fire('생성완료!', '', 'success')
                  this.$router.push({path: '/salesMix', query: {}});
                }
              }
            }
          }
        }
      })
    },
    // 공동모객,판매상품
    changeJointSales(jointSales, pdtCode) 
    {
      // 변경전 확인
      this.$swal.fire({
        text: '멤버십 할인제외되는 공동모객/판매상품(실행<->중지)상태',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let aStatus = (jointSales == "Y") ? "N" : "Y"
          // console.log(sStatus, pdtCode);
          await this.$api("/api/changeJointSalesStatus", {param: [aStatus, pdtCode]});
          // 상태변경 후, 갱신
          this.getSalesList("all");
          this.$swal.fire('변경완료!', '', 'success')
        // deny 버튼클릭 시 처리루틴
        // } else if (result.isDenied) {
        //   this.$swal.fire('Changes are not saved', '', 'info')
        }
      })
    },
    
    // 멤버십 상시할인상품
    changeAlwaysDCSales(awDCFlag, pdtCode) 
    {
      // 변경전 확인
      this.$swal.fire({
        text: '멤버십 상시할인상품(실행<->중지)상태',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let aStatus = (awDCFlag == "Y") ? "N" : "Y"
          // console.log(sStatus, pdtCode);
          await this.$api("/api/changeAlwaysDCSalesStatus", {param: [aStatus, pdtCode]});
          // 상태변경 후, 갱신
          this.getSalesList("all");
          this.$swal.fire('변경완료!', '', 'success')
        // deny 버튼클릭 시 처리루틴
        // } else if (result.isDenied) {
        //   this.$swal.fire('Changes are not saved', '', 'info')
        }
      })
    },    

    changeAuotSales(autoSales, pdtCode) 
    {
      // 변경전 확인
      this.$swal.fire({
        text: '컨펌없는 자동판매(실행<->중지)상태',
        showCancelButton: true,
        confirmButtonText: '변경',
        cancelButtonText: '취소',
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          let aStatus = (autoSales == "Y") ? "N" : "Y"
          // console.log(sStatus, pdtCode);
          await this.$api("/api/changeAutoSalesStatus", {param: [aStatus, pdtCode]});
          // 상태변경 후, 갱신
          this.getSalesList("all");
          this.$swal.fire('변경완료!', '', 'success')
        // deny 버튼클릭 시 처리루틴
        // } else if (result.isDenied) {
        //   this.$swal.fire('Changes are not saved', '', 'info')
        }
      })
    },
    // 게시순서 저장 - 순차 await 루프 대신 Promise.all로 병렬처리하여 속도개선
    async saveSortNo()
    {
      if(this.isLoading) return;

      this.isLoading = true
      try
      {
        const updatePromises = this.productMaList.map(product => {
          let sortNo = (product.sortNo != null && product.sortNo !== '') ? product.sortNo : 999;
          return this.$api("/api/pdtSortNo_update", { param: [sortNo, product.pCode] });
        });

        const results = await Promise.all(updatePromises);   // 한 건씩 순차 대기하지 않고 동시에 요청
        const hasError = results.some(r => r.affectedRows < 0 || r.affectedRows === undefined);

        if(hasError)
        {
          this.$swal.fire('', '오류발생(pdtSortNo_update)<br>시스템 관리자에게 문의바랍니다.', 'error')
          return false;
        }
        else
        {
          this.$swal.fire('', '설정처리가 완료되었습니다', 'success')
          //location.reload(true);
        }
      }
      finally
      {
        this.isLoading = false
      }
    }
  }, 
}
</script>

<style scoped>
/* ===== 디자인 토큰 ===== */
.pm-page {
  --pm-bg: #F6F7F9;
  --pm-surface: #FFFFFF;
  --pm-border: #E4E7EC;
  --pm-border-strong: #D2D7E0;
  --pm-text: #212836;
  --pm-text-muted: #6B7280;
  --pm-accent: #3454D1;
  --pm-accent-soft: #EAEFFD;
  --pm-danger: #C1443C;
  --pm-danger-soft: #FBEAE9;
  --pm-stripe: #FBFCFD;
  --pm-row-hover: #F3F6FF;

  /* 상세설정 버튼 구분용 톤 컬러 (혼동방지) */
  --tone-teal: #0D9488;
  --tone-teal-soft: #E6F5F3;
  --tone-amber: #B45309;
  --tone-amber-soft: #FBF0DF;
  --tone-violet: #7C3AED;
  --tone-violet-soft: #F1EAFE;
  --tone-indigo: #4F46E5;
  --tone-indigo-soft: #EAEAFC;
  --tone-sky: #0284C7;
  --tone-sky-soft: #E4F3FB;
  --tone-slate: #475569;
  --tone-slate-soft: #EEF0F3;
  --tone-emerald: #059669;
  --tone-emerald-soft: #E4F6EC;
  --tone-blue: #2563EB;
  --tone-blue-soft: #E9EEFC;
  --tone-purple: #9333EA;
  --tone-purple-soft: #F4E9FC;

  background: var(--pm-bg);
  color: var(--pm-text);
  font-family: -apple-system, BlinkMacSystemFont, "Malgun Gothic", "Apple SD Gothic Neo", "Segoe UI", sans-serif;
}

.pm-main {
  padding: 6px 4px 28px;
}

/* ===== 상단 검색/필터 툴바 ===== */
.pm-toolbar {
  background: var(--pm-surface);
  border: 1px solid var(--pm-border);
  border-radius: 12px;
  padding: 14px 16px 12px;
  margin-bottom: 14px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}

.toolbar-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px;
}

.toolbar-row--actions {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed var(--pm-border);
  justify-content: flex-end;
  gap: 10px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1 1 160px;
  min-width: 150px;
}

.field-group--wide {
  flex: 1 1 240px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--pm-text-muted);
  letter-spacing: .02em;
}

.field-inline {
  display: flex;
  gap: 6px;
}

.pm-select,
.pm-input {
  height: 34px;
  border: 1px solid var(--pm-border-strong);
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12.5px;
  color: var(--pm-text);
  background: var(--pm-surface);
  width: 100%;
}

.pm-select:disabled,
.pm-input:disabled {
  background: #F3F4F6;
  color: var(--pm-text-muted);
}

.pm-select:focus,
.pm-input:focus,
.pm-btn:focus-visible,
.pm-mini:focus-visible,
.chip:focus-visible,
.pm-pager__link:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--pm-accent-soft);
  border-color: var(--pm-accent);
}

.pm-btn {
  height: 34px;
  border-radius: 8px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: background .12s ease, border-color .12s ease, color .12s ease;
}

.pm-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.pm-btn--ghost {
  background: var(--pm-surface);
  border-color: var(--pm-border-strong);
  color: var(--pm-text-muted);
}
.pm-btn--ghost:hover:not(:disabled) {
  border-color: var(--pm-accent);
  color: var(--pm-accent);
}

.pm-btn--dark {
  background: var(--pm-text);
  color: #fff;
}
.pm-btn--dark:hover:not(:disabled) {
  background: #384157;
}

.pm-btn--accent {
  background: var(--pm-accent);
  color: #fff;
}
.pm-btn--accent:hover:not(:disabled) {
  background: #2A44AE;
}

.pm-btn--outline-accent {
  background: var(--pm-surface);
  border-color: var(--pm-accent);
  color: var(--pm-accent);
}
.pm-btn--outline-accent:hover:not(:disabled) {
  background: var(--pm-accent-soft);
}

/* ===== 결과 테이블 ===== */
.table-wrapper {
  position: relative;
  min-height: 80px;
}

.table-scroll {
  overflow: auto;
  max-height: 72vh;
  border: 1px solid var(--pm-border);
  border-radius: 12px;
  background: var(--pm-surface);
}

.pm-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12.5px;
}

.pm-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #F1F3F7;
  color: var(--pm-text-muted);
  font-weight: 600;
  font-size: 11.5px;
  text-align: center;
  white-space: nowrap;
  padding: 10px 8px;
  border-bottom: 1px solid var(--pm-border-strong);
}

.pm-table tbody td {
  padding: 8px;
  border-bottom: 1px solid var(--pm-border);
  vertical-align: middle;
  text-align: center;
}

.pm-table tbody tr:nth-child(even) {
  background: var(--pm-stripe);
}

.pm-table tbody tr:hover {
  background: var(--pm-row-hover);
}

.col-name { min-width: 150px; text-align: left; }
.col-cate { min-width: 150px; }
.col-actions { min-width: 235px; text-align: left; }

.mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; }
.text-accent { color: var(--pm-accent); }
.text-warn { color: var(--pm-danger); font-weight: 700; }

.seller-tags {
  display: flex;
  justify-content: center;
  gap: 3px;
  margin-bottom: 4px;
}

.tag {
  font-size: 10px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 4px;
  line-height: 1.5;
}
.tag--nt { background: #E4F5EA; color: #1F8A4C; }
.tag--nd { background: var(--pm-accent-soft); color: var(--pm-accent); }

.sort-input {
  width: 46px;
  border: 1px solid var(--pm-border-strong);
  border-radius: 6px;
  padding: 2px 4px;
  font-size: 12px;
  color: var(--pm-danger);
  text-align: center;
}

.prop-cell--d { color: #0E7C86; }
.prop-cell--f { color: #B5650A; }
.prop-sub { display: block; font-size: 10.5px; color: var(--pm-text-muted); }

.first-pay { font-size: 11.5px; color: var(--pm-text-muted); }

.remarks-cell {
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--pm-text-muted);
  text-align: left;
}

/* 행동버튼(교통/가격/사진/수정/복제/보기) */
.action-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding-bottom: 6px;
  margin-bottom: 6px;
  border-bottom: 1px dashed var(--pm-border);
}

.pm-mini {
  border: 1px solid var(--pm-border-strong);
  background: var(--pm-surface);
  color: var(--pm-text);
  border-radius: 5px;
  padding: 3px 8px;
  font-size: 11px;
  line-height: 1.5;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color .12s ease, color .12s ease, background .12s ease;
}
.pm-mini:hover:not(:disabled) {
  border-color: var(--pm-accent);
  color: var(--pm-accent);
}
.pm-mini--muted {
  background: #F3F4F6;
  border-style: dashed;
  color: #ADB3BF;
  cursor: not-allowed;
}

/* 상세설정 실행버튼(교통/가격/사진/수정/복제/보기) - 버튼이 많아 색으로 구분 */
.pm-mini--teal    { border-color: var(--tone-teal);    color: var(--tone-teal); }
.pm-mini--violet  { border-color: var(--tone-violet);  color: var(--tone-violet); }
.pm-mini--indigo  { border-color: var(--tone-indigo);  color: var(--tone-indigo); }
.pm-mini--sky     { border-color: var(--tone-sky);     color: var(--tone-sky); }
.pm-mini--slate   { border-color: var(--tone-slate);   color: var(--tone-slate); }
.pm-mini--amber   { border-color: var(--tone-amber);   color: var(--tone-amber); }

.pm-mini--teal:hover:not(:disabled)    { background: var(--tone-teal-soft); }
.pm-mini--violet:hover:not(:disabled)  { background: var(--tone-violet-soft); }
.pm-mini--indigo:hover:not(:disabled)  { background: var(--tone-indigo-soft); }
.pm-mini--sky:hover:not(:disabled)     { background: var(--tone-sky-soft); }
.pm-mini--slate:hover:not(:disabled)   { background: var(--tone-slate-soft); }
.pm-mini--amber:hover:not(:disabled)   { background: var(--tone-amber-soft); }

/* 가격이 이미 등록된 상태(채워진 톤)로 한눈에 구분 */
.pm-mini--amber-fill {
  background: var(--tone-amber);
  border-color: var(--tone-amber);
  color: #fff;
  font-weight: 600;
}
.pm-mini--amber-fill:hover:not(:disabled) {
  background: #93440A;
  color: #fff;
}

/* 토글칩(판매/전시/삭제/큐잉/추천/베스트/뱃지/그룹/신규/공동/할인/지금) */
.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 4px;
}
.chip-row:last-child { margin-bottom: 0; }

.chip {
  border: 1px solid var(--pm-border-strong);
  background: var(--pm-surface);
  color: var(--pm-text-muted);
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 11px;
  line-height: 1.6;
  cursor: pointer;
  white-space: nowrap;
  transition: background .12s ease, border-color .12s ease, color .12s ease;
}
.chip:hover:not(:disabled) {
  border-color: var(--pm-accent);
  color: var(--pm-accent);
}
.chip--on {
  background: var(--pm-accent);
  border-color: var(--pm-accent);
  color: #fff;
  font-weight: 600;
}
.chip--on:hover {
  background: #2A44AE;
  color: #fff;
}
.chip--danger-on {
  background: var(--pm-danger);
  border-color: var(--pm-danger);
  color: #fff;
  font-weight: 600;
}
.chip--danger-on:hover {
  background: #A6362F;
  color: #fff;
}

/* 상세설정 상태칩(판매/전시/삭제/큐잉) - 톤을 서로 다르게 줘서 한눈에 구분 */
.chip--sale    { border-color: var(--tone-emerald); color: var(--tone-emerald); }
.chip--display { border-color: var(--tone-blue);    color: var(--tone-blue); }
.chip--delete  { border-color: var(--pm-danger);    color: var(--pm-danger); }
.chip--cue     { border-color: var(--tone-purple);  color: var(--tone-purple); }

.chip--sale:hover:not(.chip--on)    { background: var(--tone-emerald-soft); }
.chip--display:hover:not(.chip--on) { background: var(--tone-blue-soft); }
.chip--delete:hover:not(.chip--on)  { background: var(--pm-danger-soft); }
.chip--cue:hover:not(.chip--on)     { background: var(--tone-purple-soft); }

/* on(켜짐) 상태는 각 톤으로 꽉 채워 표시 - 톤 클래스와 결합해 항상 우선 적용되도록 함 */
.chip--sale.chip--on {
  background: var(--tone-emerald);
  border-color: var(--tone-emerald);
  color: #fff;
}
.chip--sale.chip--on:hover { background: #04724F; color: #fff; }

.chip--display.chip--on {
  background: var(--tone-blue);
  border-color: var(--tone-blue);
  color: #fff;
}
.chip--display.chip--on:hover { background: #1D4FC4; color: #fff; }

.chip--delete.chip--danger-on {
  background: var(--pm-danger);
  border-color: var(--pm-danger);
  color: #fff;
}
.chip--delete.chip--danger-on:hover { background: #A6362F; color: #fff; }

.chip--cue.chip--on {
  background: var(--tone-purple);
  border-color: var(--tone-purple);
  color: #fff;
}
.chip--cue.chip--on:hover { background: #7C24C4; color: #fff; }

/* ===== 로딩 오버레이 ===== */
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.82);
  border-radius: 12px;
}

/* ===== 페이지네이션 ===== */
.pm-pager-wrap {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.pm-pager {
  display: flex;
  gap: 4px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.pm-pager__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 6px;
  border-radius: 7px;
  border: 1px solid var(--pm-border-strong);
  color: var(--pm-text-muted);
  font-size: 12.5px;
  cursor: pointer;
  background: var(--pm-surface);
}
.pm-pager__link:hover {
  border-color: var(--pm-accent);
  color: var(--pm-accent);
  background: var(--pm-accent-soft);
}

/* ===== 반응형(좁은 화면) ===== */
@media (max-width: 900px) {
  .field-group,
  .field-group--wide {
    flex-basis: 100%;
  }
}
</style>